import Alert from "./ui/AlertDisplay.vue";
import DismissButton from "./ui/DismissButton.vue";

const AlertComponent = Object.assign({}, Alert, {
  DismissButton: DismissButton,
});

export default AlertComponent;
